import { render, staticRenderFns } from "./BrandDetail.vue?vue&type=template&id=705aa084&scoped=true"
import script from "./BrandDetail.vue?vue&type=script&lang=js"
export * from "./BrandDetail.vue?vue&type=script&lang=js"
import style0 from "./BrandDetail.vue?vue&type=style&index=0&id=705aa084&prod&scoped=true&lang=css"
import style1 from "./BrandDetail.vue?vue&type=style&index=1&id=705aa084&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705aa084",
  null
  
)

export default component.exports